import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import ChartComponent from "../Highcharts/ChartComponent";
import { UserCasesColumnConfig } from "../Highcharts/chartconfig";
import axios from "axios";
import Loader from "./Loader";

function UserReportedCases({ requestData }) {
  const [chartCounter, setChartCounter] = useState(null);

  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      userIdentifier: "Type of user",
    };
    if (Object.keys(requestData).length > 0) {
      let oRequest = { ...requestBody, ...requestData };
      if (
        requestData?.globalFilters?.dateFilter.to !== "" &&
        requestData?.globalFilters?.dateFilter.from !== ""
      ) {
        getUserData(oRequest);
      }
    } else {
      getUserData(requestBody);
    }
  }, [requestData]);

  let getUserData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/countiesOrUserTypeReportingCases `,
        data
      );
      let formatedData = res.data.data;
      let sortedArray = Object.entries(formatedData)
      .sort((a, b) => b[1] - a[1]);
  
      let sortedFormatedData = Object.fromEntries(sortedArray);
      let catagoriesArr = Object.keys(sortedFormatedData);
      let chartValues = Object.values(sortedFormatedData);
      let percentValues = [];

      Object.keys(formatedData)
        .slice(0, 11)
        .forEach((key, index) => {
          let percentVal;
          if (sortedFormatedData[key] !== 0 && totalValue(sortedFormatedData) !== 0) {
            percentVal = Math.round(
              (sortedFormatedData[key] / totalValue(sortedFormatedData)) * 100
            );
          } else {
            percentVal = 0;
          }
          let obj = {
            percent: percentVal,
            y: sortedFormatedData[key],
          };
          percentValues = [...percentValues, obj];
        });

      let obj = {
        catagoriesArr,
        percentValues,
      };
      setChartCounter(obj);
    } catch (error) {
      console.log(error);
    }
  };

  const totalValue = (data) => {
    let values = Object.values(data);
    const sumWithIndictors = values.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    return sumWithIndictors;
  };
  return (
    <Card>
      {/* <Card.Header>Top 10 Counties reporting cases</Card.Header> */}
      <Card.Body className="pb-2">
        <h5>Distribution of reported all cases by type of user</h5>
        {chartCounter !== null ? (
          <ChartComponent options={UserCasesColumnConfig(chartCounter)} />
        ) : (
          <Loader />
        )}
      </Card.Body>
    </Card>
  );
}

export default UserReportedCases;
